/**
 * Converts a design's px measurement into rem, against the console's 12px root.
 *
 * Everything the broker experience sizes goes through this: type, spacing,
 * padding, radii, icon and track geometry. The console pins its root font to
 * 12px and re-bases it at wider viewports, so a hardcoded px value stops scaling
 * with the text around it and a layout's proportions come apart at width.
 *
 * Not Mantine's `rem`, which always divides by 16 and so renders everything a
 * quarter smaller than intended under a 12px root.
 *
 * The console keeps its own copy in `components/panels/panelLayout.ts`, which
 * this library cannot import. The two are pinned together by a test in the
 * console, `personas/broker/rem.agreement.test.ts`.
 */
export const rem = (value: number): string => `${value / 12}rem`;
